export default __webpack_public_path__ + "static/media/grinChristmasLogo.ff4a93e2.svg";